import React, { FC } from "react"

import { Button, Card } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"

import Page from "../components/layouts/page/Page"
import GroupsTable from "../features/groups/groups-table/GroupsTable"
import CreateGroupModal from "../features/groups/create-group-modal/CreateGroupModal"
import { useLanguage } from "../contexts/language-context"
import { useAuth } from "../contexts/authentication-context"
import RequiresRole from "../features/auth/components/require-auth/RequiresRole"

const Groups: FC = () => {
    const [opened, { open, close }] = useDisclosure(false)
    const { L } = useLanguage()

    return (
        <Page
            title={L("Groups")}
            primaryAction={
                <RequiresRole role="edit-devices">
                    <Button leftIcon={<IconPlus size={26} stroke={1.5} />} onClick={open}>
                        {L("New group")}
                    </Button>
                </RequiresRole>
            }
        >
            <Card>
                <GroupsTable />
            </Card>
            <CreateGroupModal opened={opened} onClose={close} />
        </Page>
    )
}

export default Groups
